// extracted by mini-css-extract-plugin
export default {"container":"t_-z","tab":"u_-z","selected":"v_-z"};